import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Repo } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import Timestamp from "components/Timestamp";

const SpaceliftVcsReposTableCreatedAtCell = ({
  item: repo,
  ...cellProps
}: TableSimpleCellProps<Repo>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp timestamp={repo.createdAt} />
    </TableSimpleCell>
  );
};

export default SpaceliftVcsReposTableCreatedAtCell;
